import { useEffect, useState } from 'react'
import { degreeMap, sessionMap, degreeTypeMap, data, courseMap, studentMarksData } from '../js/data';
import { useNavigate } from 'react-router-dom';

const Foot = () => {
    const [formData, setFormData] = useState({
        resultType: 0,
        session: 21,
        degreeType: 1,
        course: 0,
        degree: 0
    });

    const [selectedResult, setSelectedResult] = useState(null);
    const [matchedData, setMatchedData] = useState([]);
    const [rollNumber, setRollNumber] = useState('');
    const [captcha, setCaptcha] = useState('');
    const [captchaValue, setCaptchaValue] = useState(8);
    const [currentFilters, setCurrentFilters] = useState(null);
    const [showResultsTable, setShowResultsTable] = useState(false);
    const [showRollForm, setShowRollForm] = useState(false);
    const [finalStudent, setFinalStudent] = useState(null);
    const [captchaEquation, setCaptchaEquation] = useState('6 + 2 = ');
    const [hideFirstForm, setHideFirstForm] = useState(true);
    const [resultInfo, setResultInfo] = useState(null);

    const navigate = useNavigate()

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleViewClick = (e) => {
        e.preventDefault();

        if (formData.degree === 0 || formData.course === 0 || formData.resultType === 0) {
            alert("Please select all fields");
            return;
        }

        const degreeName = degreeMap[formData.degree];
        const sessionKey = sessionMap[formData.session]; // Get session key like "2020-21"


        const degreeData = data[degreeName];

        if (!degreeData) {
            alert("No results found");
            return;
        }

        const resultData = degreeData[sessionKey];

        if (!resultData || resultData.length === 0) {
            alert(`No results found`);
            return;
        }

        setResultInfo({
            degreeName: degreeName,
            session: sessionKey,
            degreeType: degreeTypeMap[formData.degreeType],
            time: resultData.session || ''
        });
        setShowRollForm(false);

        setMatchedData(resultData);

        setShowResultsTable(true);
        setShowRollForm(false);
        setFinalStudent(null);
    };

    const handleResultSelect = (resultName) => {
        setSelectedResult(resultName);
        setShowRollForm(true);
        setHideFirstForm(false);
        setShowResultsTable(false);
        setFinalStudent(null);
    };
    // const getCurrentFiltersDisplay = () => {
    //     if (!currentFilters) return '';

    //     const sessionLabel = sessionMap[currentFilters.session] || currentFilters.session;
    //     const degreeTypeLabel = degreeTypeMap[currentFilters.degreeType] || currentFilters.degreeType;
    //     const courseLabel = courseMap[currentFilters.course] || currentFilters.course;
    //     const degreeLabel = degreeMap[currentFilters.degree] || currentFilters.degree;

    //     return `Session: ${sessionLabel}, Degree Type: ${degreeTypeLabel}, Course: ${courseLabel}, Degree: ${degreeLabel}`;
    // };

    // const handleGetResult = (e) => {
    //     e.preventDefault();

    //     if (parseInt(captcha) !== captchaValue) {
    //         alert("Invalid captcha");
    //         generateNewCaptcha();
    //         return;
    //     }

    //     const student = matchedData.find(
    //         (s) => s.rollNumber === rollNumber.trim()
    //     );

    //     if (!student) {
    //         alert("Roll number not found");
    //         return;
    //     }

    //     setHideFirstForm(false);
    //     setFinalStudent(student);
    //     setShowRollForm(false);
    //     setShowResultsTable(false);
    //     navigate('/mark-sheet', { 
    //         state: { 
    //             student: completeStudentData,
    //             resultInfo: resultInfo,
    //             formData: formData
    //         } 
    //     });
    //     navigate('/mark-sheet', { state: { student } });
    // };

    const handleGetResult = (e) => {
        e.preventDefault();

        if (parseInt(captcha) !== captchaValue) {
            alert("Invalid captcha");
            generateNewCaptcha();
            return;
        }

        const student = matchedData.find(
            (s) => s.rollNumber === rollNumber.trim()
        );

        if (!student) {
            alert("Roll number not found");
            return;
        }

        // Get detailed marks data for the student
        // const detailedMarksData = studentMarksData[formData.degreeName]?.find(
        //     s => s.rollNumber === rollNumber.trim()
        // ) || student.marksData;
        const degreeName = resultInfo.degreeName;
        const sessionKey = resultInfo.session;

        const detailedMarksData = studentMarksData[degreeName]?.[sessionKey]?.find(
            s => s.rollNumber === rollNumber.trim()
        ) || student.marksData;
        // Prepare complete student data for marksheet
        const completeStudentData = {
            ...student,
            detailedMarks: detailedMarksData,
        };

        setHideFirstForm(false);
        setFinalStudent(completeStudentData);
        setShowRollForm(false);
        setShowResultsTable(false);

        // Navigate to marksheet with all data
        navigate('/mark-sheet', {
            state: {
                student: completeStudentData,
                resultInfo: resultInfo,
                formData: formData
            }
        });
    };


    const generateNewCaptcha = () => {
        const num1 = Math.floor(Math.random() * 10);
        const num2 = Math.floor(Math.random() * 10);
        setCaptchaValue(num1 + num2);
        setCaptchaEquation(`${num1} + ${num2} = `);
    };
    const handleReset = () => {
        setHideFirstForm(true);
        setShowRollForm(false);
        setRollNumber('');
        setCaptcha('');
        generateNewCaptcha();
        setFormData({
            resultType: 0,
            session: 21,
            degreeType: 1,
            course: 0,
            degree: 0
        })
    };

    // Initialize captcha on component mount
    useEffect(() => {
        generateNewCaptcha();
    }, []);
    return (
        <div>
            <div className="row">
                <form
                    name="form1"
                    method="post"
                    onSubmit={handleViewClick}
                    id="form1"
                >{hideFirstForm && (
                    <div className="master-body form-horizontal">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="form-group">
                                    <div className="col-sm-12 text-center">
                                        <span id="Anthem_lbltext__">
                                            <span
                                                id="lbltext"
                                                style={{
                                                    color: "#000DFF",
                                                    fontFamily: "Calibri",
                                                    fontSize: 20,
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                MJPRU - Examination Results
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                {/* Form fields */}

                                <div className="form-group">
                                    <label id="lb_ResultType" className="col-sm-4 control-label">
                                        Result Type
                                    </label>
                                    <div className="col-sm-4 required">
                                        <select
                                            name="resultType"
                                            id="rb_ResultType"
                                            className="form-control"
                                            value={formData.resultType}
                                            onChange={handleFormChange}
                                        >
                                            <option value={0}>--Select--</option>
                                            <option value={1}>Main Result</option>
                                            <option value={2}>Re-Evaluation Result</option>
                                            <option value={3}>Improvement Result</option>
                                            <option value={4}>Supplementary/Back Result</option>
                                            <option value={5}>Single Subject Result</option>
                                            <option value={6}>Left Out (Practical)</option>
                                            <option value={7}>Special Permission</option>
                                        </select>
                                        *
                                    </div>
                                </div>

                                {/* Other form fields with similar pattern */}
                                <div className="form-group">
                                    <label id="lblSession" className="col-sm-4 control-label">
                                        Academic Session
                                    </label>
                                    <div className="col-sm-4 required">
                                        <select
                                            name="session"
                                            id="D_ddlsession"
                                            className="form-control"
                                            value={formData.session}
                                            onChange={handleFormChange}
                                        >
                                            {Object.entries(sessionMap)
                                                .sort(([keyA], [keyB]) => keyB - keyA) // Sort by key in descending order
                                                .map(([key, value]) => (
                                                    <option key={key} value={key}>
                                                        {value}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label id="lblDegreeType" className="col-sm-4 control-label">
                                        Select Degree Type
                                    </label>
                                    <div className="col-sm-4 required">
                                        <span id="Anthem_D_ddlDegreeType__">
                                            <select
                                                name="degreeType"
                                                id="D_ddlDegreeType"
                                                className="form-control"
                                                value={formData.degreeType}
                                                onChange={handleFormChange}
                                            >
                                                <option value={1}>SEMESTER</option>
                                                <option value={2}>ANNUAL</option>
                                            </select>
                                        </span>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label id="lblcourse" className="col-sm-4 control-label">
                                        Select Course
                                    </label>
                                    <div className="col-sm-4 required">
                                        <span id="Anthem_Ddlcourse__">
                                            <select
                                                name="course"
                                                id="Ddlcourse"
                                                className="form-control"
                                                value={formData.course}
                                                onChange={handleFormChange}
                                            >
                                                <option value={0}>--Select Course--</option>
                                                <option value={1}>PG Diploma</option>
                                                <option value={3}>Ph.D</option>
                                                <option value={5}>Post Graduate (PG)</option>
                                                <option value={7}>UG Diploma</option>
                                                <option value={8}>Under Graduate (UG)</option>
                                                <option value={15}>
                                                    Diploma (Paramedical/Nursing)
                                                </option>
                                            </select>
                                        </span>
                                        *
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label id="lblDegree" className="col-sm-4 control-label">
                                        Degree
                                    </label>
                                    <div className="col-sm-4 required">
                                        <span id="Anthem_DdlDegree__">
                                            <select
                                                name="degree"
                                                id="DdlDegree"
                                                className="form-control"
                                                value={formData.degree}
                                                onChange={handleFormChange}
                                            >
                                                <option value={0}>--Select Course--</option>
                                                <option value={3}>B.A(Yearly)</option>
                                                <option value={4}>B.Com(Yearly)</option>
                                                <option value={5}>B.Sc(Yearly)</option>
                                                <option value={6}>B.B.A</option>
                                                <option value={7}>B.C.A.</option>
                                                <option value={8}>B.Pharma</option>
                                                <option value={9}>B.Tech</option>
                                                <option value={10}>BHM &amp; CT</option>
                                                <option value={11}>B.Com Finance</option>
                                                <option value={12}>B.Com Financial Service</option>
                                                <option value={13}>B.Sc. (Hons) Agriculture</option>
                                                <option value={14}>B.Sc. AGRICULTURE</option>
                                                <option value={15}>LLB</option>
                                                <option value={16}>B.A L.L.B (5 Years)</option>
                                                <option value={17}>B.Lib</option>
                                                <option value={18}>B.Pharma (Old)</option>
                                                <option value={19}>
                                                    Bachelor of Management Studies
                                                </option>
                                                <option value={20}>
                                                    B.Sc. Home Science (Semester)
                                                </option>
                                                <option value={49}>M.B.B.S</option>
                                                <option value={50}>B.D.S</option>
                                                <option value={89}>B.A.M.S</option>
                                                <option value={90}>B.Com. (Honors)</option>
                                                <option value={91}>B.Com. (Computer)</option>
                                                <option value={92}>B.Sc (Computer Science)</option>
                                                <option value={93}>B.Sc (Microbiology)</option>
                                                <option value={94}>B.Sc (Honors)</option>
                                                <option value={95}>B.Sc. (Biotechnology)</option>
                                                <option value={96}>B.Sc. (Home Science)</option>
                                                <option value={97}>BUMS</option>
                                                <option value={98}>B.Sc. NURSING</option>
                                                <option value={99}>B.Sc Post Basic (Nursing)</option>
                                                <option value={100}>
                                                    Bachelor of Operation Theatre Technology
                                                </option>
                                                <option value={101}>B.ED (Campus)</option>
                                                <option value={102}>B.ED (Yearly)</option>
                                                <option value={103}>B.SC PHYSIOTHERAPY</option>
                                                <option value={104}>
                                                    B.Sc. In Medical Laboratory Techniques
                                                </option>
                                                <option value={105}>
                                                    B.Sc. In Radiological Imaging Techniques
                                                </option>
                                                <option value={106}>Bachelor of Optometry</option>
                                                <option value={107}>B.EL.ED</option>
                                                <option value={108}>
                                                    B.Sc. Agriculture (Special Permission)
                                                </option>
                                            </select>
                                        </span>
                                    </div>
                                </div>

                                {/* Add similar onChange handlers for other select fields */}

                            </div>
                            <table cellPadding={0} cellSpacing={0} border={0}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="submit"
                                                name="btnView"
                                                value="View"
                                                id="btnView"
                                                className="button-common"
                                            />
                                        </td>
                                        <td className="btngap" />
                                    </tr>
                                </tbody>
                            </table>

                            {/* Results Table */}
                            {showResultsTable && (
                                <div className="col-md-12" id="show_result">
                                    <div className="row">
                                        <div id="pnalpg">
                                            <div className="table-responsive">
                                                <table
                                                    width="100%"
                                                    className="table"
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                    border={0}
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                className="tableheadingmain"
                                                                colSpan={5}  // <-- optional, if you want it to stretch across the entire row
                                                                style={{
                                                                    background: "#0b6391",
                                                                    color: "#fff",
                                                                    fontSize: 14
                                                                }}
                                                            >
                                                                {resultInfo.degreeType} Examination Results {resultInfo.session} – {resultInfo.degreeName}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td className="apiscroll">
                                                                <div style={{ width: "100%", border: "none", float: "left" }}>
                                                                    <div className="divDownload">
                                                                        <div style={{ width: "100%" }}>
                                                                            <ul style={{ listStyleType: "none", width: "100%", padding: 0 }}>
                                                                                <table
                                                                                    cellSpacing={1}
                                                                                    cellPadding={1}
                                                                                    rules="all"
                                                                                    border={1}
                                                                                    id="dgResultPG"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        border: "1px solid #D4D4D4",
                                                                                        borderCollapse: "collapse"
                                                                                    }}
                                                                                >
                                                                                    <tbody>
                                                                                        <tr className="header-style">
                                                                                            <td>S.No.</td>
                                                                                            <td>Name of the Result</td>
                                                                                            <td>Action</td>
                                                                                        </tr>
                                                                                        <tr className="item-style">
                                                                                            <td align="center" style={{ width: "3%" }}>1</td>

                                                                                            <td align="left">
                                                                                                {resultInfo.degreeName}
                                                                                                <br />
                                                                                                <span style={{ fontSize: 12, fontFamily: "Calibri" }}>
                                                                                                    {resultInfo.time}
                                                                                                </span>
                                                                                            </td>

                                                                                            <td align="center">
                                                                                                <button
                                                                                                    className="button-common"
                                                                                                    onClick={() => handleResultSelect(resultInfo.degreeName)}
                                                                                                    style={{ padding: "5px 10px", fontSize: "12px" }}
                                                                                                >
                                                                                                    Select
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>)}
                </form>
            </div>

            {/* Result Container */}
            {showRollForm && (
                <div className="col-md-12" id="result-container" style={{ display: selectedResult ? 'block' : 'none' }}>
                    <form name="form2" method="post" id="form2" onSubmit={handleGetResult}>
                        <input type="hidden" name="result_id" id="result_id" value={selectedResult || ''} />
                        <div className="master-body form-horizontal">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="form-group">
                                        <div className="col-sm-12 text-center">
                                            <span>
                                                <span
                                                    id="result_name"
                                                    style={{
                                                        color: "#000DFF",
                                                        fontFamily: "Calibri",
                                                        fontSize: 20,
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    {selectedResult}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label id="lb_RollNumber" htmlFor="rb_RollNumber" className="col-sm-4 control-label">
                                            Roll Number
                                        </label>
                                        <div className="col-sm-4 required">
                                            <input
                                                type="text"
                                                name="rb_RollNumber"
                                                id="rb_RollNumber"
                                                className="form-control"
                                                placeholder="Enter Roll Number"
                                                style={{ width: "96%" }}
                                                value={rollNumber}
                                                onChange={(e) => setRollNumber(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-4 control-label" htmlFor="rb_captcha">
                                            <img
                                                alt="refresh"
                                                src="https://mjpruiums.in/(S(ep03qioshppaovjjfzzrjamy))/App_Themes/skyblue/Images/refresh-icon.jpg"
                                                width="18px"
                                                style={{ cursor: "pointer", marginRight: 2 }}
                                                onClick={generateNewCaptcha}
                                            />
                                            <span id="captcha-equation">{captchaEquation}</span>
                                        </label>
                                        <div className="col-sm-4 required">
                                            <input
                                                type="hidden"
                                                name="rb_captcha_value"
                                                id="rb_captcha_value"
                                                value={captchaValue}
                                            />
                                            <input
                                                type="text"
                                                name="rb_captcha"
                                                id="rb_captcha"
                                                className="form-control"
                                                placeholder="?"
                                                style={{ width: "96%" }}
                                                value={captcha}
                                                onChange={(e) => setCaptcha(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-sm-4" />
                                        <div className="col-sm-4 required">
                                            <input
                                                type="submit"
                                                name="btnGetResult"
                                                value="Get Result"
                                                className="button-common"
                                                style={{ width: "46%", marginRight: "4%" }}
                                            />
                                            <input
                                                type="button"
                                                name="btnReset"
                                                value="Reset"
                                                className="button-common"
                                                style={{ width: "46%" }}
                                                onClick={handleReset}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            )}
            {finalStudent && (
                <div className="col-md-12" style={{ marginTop: 20 }}>
                    <h3>Result for {finalStudent.name}</h3>
                    <table className="table table-bordered">
                        <tbody>
                            <tr><th>Roll Number</th><td>{finalStudent.rollNumber}</td></tr>
                            <tr><th>Name</th><td>{finalStudent.name}</td></tr>
                            <tr><th>Marks</th><td>{finalStudent.marks}</td></tr>
                            <tr><th>Grade</th><td>{finalStudent.grade}</td></tr>
                            <tr><th>Status</th><td>{finalStudent.status}</td></tr>
                        </tbody>
                    </table>
                </div>
            )}

            <div id="fullPageLoader" style={{ display: "none" }}>
                <div className="loader-backdrop" />
                <div className="loader-spinner">
                    <div
                        className="spinner-border text-primary"
                        role="status"
                        style={{ width: "4rem", height: "4rem" }}
                    >
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Foot
